/**
 * Abstract Store
 */

define(function(require, exports, module) {
    'use strict';

    var $ = require('j');
    var BaseModel = require('common/base.model');
    var BaseCollection = require('common/base.collection');
    var core = require('core');

    module.exports = BaseModel.extend({
        /**
         * Collection with favorites models
         * @type {Backbone.Collection}
         */
        _collection: new BaseCollection(),

        initialize: function() {
            Object.defineProperty(this, 'state', {
                get: function() {
                    return this._stateGetter();
                }.bind(this),
                set: function() {
                    core.error('\'state\' is a read only property. Use store public methods to modify state');
                }
            });
            this.listenTo(this._collection, 'all', this.trigger);
        },

        defaults: {
            /**
             * Current store state
             * @type {String}
             */
            state: 'pending',
            /**
             * Is request sent determining property. Used for handling requests caching
             * @type {Boolean}
             */
            isInitialized: false
        },

        getItem: function(id) {
            return this._collection.findWhere({
                id: id
            });
        },

        hasItem: function(id) {
            return Boolean(this.getItem(id));
        },

        addItem: function(model) {
            return this._collection.add(model);
        },

        /**
         * Set new state
         * @param {String} [state] - new state ['pending', 'resolved', 'rejected']
         */
        _setState: function(state) {
            this.set('state', state || 'pending');
        },

        _stateGetter: function() {
            return this._collection.toJSON();
        },

        _handleFetch: function(fetchFunction, isForceUpdate) {
            if (isForceUpdate || !this.get('isInitialized')) {
                this._setState();
                this.set('isInitialized', true);

                fetchFunction()
                    .done(this._setState.bind(this, 'resolved'))
                    .fail(this._setState.bind(this, 'rejected'));
            }
            return this._getState();
        },

        _getState: function() {
            var result = $.Deferred();

            this.listenToOnce(this, 'change:state', function() {
                if (this.get('state') === 'resolved') {
                    result.resolve(this._collection.toJSON());
                } else if (this.get('state') === 'rejected') {
                    result.reject([]);
                }
            }, this);
            if (this.get('state') === 'resolved') {
                result.resolve(this._collection.toJSON());
            }

            return result.promise();
        },

        /**
         * Get favorites/recently from the server
         * @return {Deferred}
         */
        fetch: function(isForceUpdate) {
            return this._handleFetch(this._collection.fetch.bind(this._collection), isForceUpdate);
        },

        /**
         * Clear favorites store
         */
        clear: function() {
            this._collection.reset([], {silent: true});
            this.set('isInitialized', false);
            this._setState();
        },

        refetch: function() {
            this.clear();
            return this.fetch();
        }
    });
});
